/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useEffect, useMemo } from "react";
// import { useDispatch } from "react-redux";

// import warn from "../constants/toast";
import { hubsSocket } from "../services/socket.IO";

const Socket = () => {
  const socketLead = useMemo(
    () => hubsSocket.getConnectionHubCadastroLead(),
    []
  );

  useEffect(() => {
    const toJson = localStorage.getItem("@token");
    const userData = toJson == null ? null : JSON.parse(toJson);

    if (!socketLead || !userData?.token) {
      return;
    }

    socketLead
      .start()
      .then(() => {
        socketLead.on("CadastroLead", (success, message, dadosCadastro) => {
          console.log("succes", success);
          console.log("message", message);
          console.log("dadosLead", dadosCadastro);
        });
      })
      .catch((e) => {
        console.log("Error socket", e);
      });
  }, [socketLead]);
};
export default Socket;
